import h from "../core/createElement";
import Btn from "./btn";


export default function BorderBox({ title, buttons, contentClass, containerClass }, children) {

    return (
        <section class={"flex-column borderbox-container " + (containerClass ? containerClass : "")}>
            <div class="flex justify-space-between">
                <h3 class="anchor-title">{title}</h3>
                <div class="btns">
                    {buttons}
                </div>
            </div>
            <section class={"borderbox " + (contentClass ? contentClass : "")}>
                {children}
            </section>
        </section>
    );
};